import { useTranslation } from "react-i18next"

import { ReversalDialog } from "@/components/commons/reversal-dialog"
import { useReverseCycleMutation } from "@/services/subscriptions/reverse-cycle"

interface ReverseCycleDialogProps {
  subscriptionId: string
  cycleId: string
  open: boolean
  setOpen: (open: boolean) => void
}

/**
 * Reversão do ciclo de assinatura, acionada na linha do próprio ciclo.
 *
 * Difere da reversão do pedido: aqui o alvo é a cobrança de um ciclo, e a rota carrega a
 * assinatura junto — o core resolve o ciclo pelos dois identificadores.
 */
export const ReverseCycleDialog = ({
  subscriptionId,
  cycleId,
  open,
  setOpen,
}: ReverseCycleDialogProps) => {
  const { t } = useTranslation()

  const { mutateAsync: reverseCycle } =
    useReverseCycleMutation()

  return (
    <ReversalDialog
      description={t(
        "subscriptions.cycleReversal.description"
      )}
      onConfirm={({ reason, forced }) =>
        reverseCycle({
          subscriptionId,
          cycleId,
          reason,
          forced,
        })
      }
      open={open}
      setOpen={setOpen}
      successForcedMessage={t(
        "subscriptions.cycleReversal.successForced"
      )}
      successMessage={t(
        "subscriptions.cycleReversal.success"
      )}
      title={t("subscriptions.cycleReversal.title")}
    />
  )
}
